import { render, staticRenderFns } from "./dynamic-img.vue?vue&type=template&id=43b2abd6&"
import script from "./dynamic-img.vue?vue&type=script&lang=js&"
export * from "./dynamic-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default})
